import React, { Component } from 'react';
/**
 * Ref: RR_PC_02
 * Importing the action and store file and set to an object.
 */
import * as BuildHistoryAction from '../actions/BuildHistoryAction';
import BuildHistoryStore from '../stores/BuildHistoryStore';
import * as CookieService from '../CookieService';
import SDIConstants from '../SDIConstants';
import * as $ from 'jquery';
import ReactPaginate from 'react-paginate';
import DatePicker from "react-datepicker";
import BreadCrumpData from '../stores/BreadCrumpStore';
import * as MenuAction from '../actions/MenuAction';
import MenuStore from '../stores/MenuStore';
import { withTranslation, Trans } from 'react-i18next'
import Select from 'react-select';
import swal from 'sweetalert';
let isFromLink = false;
let strurlParams = "";
let qp = ""
let currentPagePath;
let mob_Session_USERID = ""
let mob_Session_BUSUNIT = ""
let Token = ""
let Password = "";
let pathUrl = CookieService.getLocalStorageValues("Session_PageName");
/*[08/22/22 , PC_04]Accessing STKIssueCart and RMA from mobile for web view - Priyanka D*/
const urlParams = window.location.search;
if (urlParams.includes("?qp_mob")) {
    strurlParams = urlParams.toString()
    if (strurlParams.includes("?qp_mob")) {

        let StrURL = strurlParams.split("?qp_mob=")
        let DecodedQueryparams = StrURL[1].toString();
        qp = atob(DecodedQueryparams);
        let QueryParams = qp.split("&")
        mob_Session_USERID = QueryParams[0].replace("mob_Session_USERID=", "");
        mob_Session_BUSUNIT = QueryParams[1].replace("mob_Session_BUSUNIT=", "");
        Password = QueryParams[2].replace("Password=", "");
        Token = QueryParams[3].replace("Token=", "");
        if (mob_Session_USERID || mob_Session_BUSUNIT || Token) {
            isFromLink = true;

            //Update the User ID and Token in cookie to invoke secure controller
            CookieService.updateLocalStorageValues("Session_UserID", mob_Session_USERID)
            CookieService.setCookieValues(SDIConstants.access_token, Token)
        }
    }
}
class BuildHistoryComponent extends Component {
    constructor(props) {
        super(props);
        this.AssignReleaseNotesHistory = this.AssignReleaseNotesHistory.bind(this);
        this.state = {
            VersionsDD: [],
            VersionTaskArray: [],
            PrevNav: "-",
            NextNav: "-",
            SelectedVersionsInd: 0,
            historyArray: [],
            SelectedVersionsDate: "",
            SelectedVersionsName: "",
            SelectedVersionsNo: "",
            Versionchange: ""
        }
    }
    componentDidMount() {
        
        BuildHistoryStore.on('VersionHistoryData', this.AssignReleaseNotesHistory);
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        let Src = "Web";
        if (isFromLink) {
            Src = "Mob";
        }
        this.GetReleaseNotesHistory(Src);
        //BuildHistoryStore.on('VersionHistoryData', this.AssignReleaseNotesHistory);

    }
    componentWillUnmount() {
        BuildHistoryStore.removeListener('VersionHistoryData', this.AssignReleaseNotesHistory);
    }
    GetReleaseNotesHistory = (Src) => {
        let ReleaseNotesBO = {
            Source: Src
        }
        BuildHistoryAction.GetReleaseNotesHistory(ReleaseNotesBO);
    }
    AssignReleaseNotesHistory = () => {

        let historyResponse = JSON.parse(BuildHistoryStore.PageLoad);
        let ErrorArray = historyResponse.ErrorTable;
        if (ErrorArray != undefined) {
            if (ErrorArray.length > 0) {
                if (ErrorArray[0].ErrorMsg == "Error Occured") {
                    $(`#${SDIConstants.SDILoader}`).addClass('hide');
                    swal({
                        allowOutsideClick: false,
                        closeOnClickOutside: false,
                        text: 'Oops, something went wrong!'
                    });
                }
                else {
                    let VersionsArray = [];
                    let HistoryArray = historyResponse.HistoryTable;
                    let VersionDD = [];
                    let TasksArray = [];
                    let Prev = "-";
                    let Next = "-";
                    let SelectedVerInd = 0;
                    let SelectedVerName = "";
                    let buildDate;
                    if (HistoryArray != undefined) {
                        if (HistoryArray.length > 0) {
                            VersionsArray = HistoryArray.filter((v, i, a) => a.findIndex(t => (t.VERSION_NO.trim().toUpperCase() === v.VERSION_NO.trim().toUpperCase())) === i);
                            VersionsArray.forEach((value, index) => {
                                let obj;
                                if (isFromLink) {
                                    obj = {
                                        label: "App Version:" + value.VERSION_NO,
                                        value: value.VERSION_NO
                                    }
                                }
                                else {
                                    obj = {
                                        label: "Web Version:" + value.VERSION_NO,
                                        value: value.VERSION_NO
                                    }
                                }
                                VersionDD.push(obj);
                            });
                        }
                        TasksArray = HistoryArray.filter((x) => x.VERSION_NO == VersionDD[0].value);
                        TasksArray = TasksArray.sort((a, b) => a.TASK_NO - b.TASK_NO);
                        if (VersionDD.length > 1) {
                            Prev = VersionDD[1].label;
                        }
                        buildDate = TasksArray[0].ADD_DTTM;
                        SelectedVerName = VersionDD[0].label;
                        let date;
                        let month;
                        let year;
                        let FullDate = new Date(buildDate);
                        year = FullDate.getFullYear();
                        month = FullDate.toLocaleString("default", { month: "long" });
                        date = FullDate.getDate()
                        buildDate = month + " " + date + ", " + year;
                        let id = "v-pills-home-tab" + "0";
                        $(`#${id}`).addClass('active');

                        this.setState({
                            VersionsDD: VersionDD, VersionTaskArray: TasksArray, PrevNav: Prev, NextNav: Next, historyArray: HistoryArray,
                            SelectedVersionsInd: SelectedVerInd, SelectedVersionsDate: buildDate, SelectedVersionsNo: VersionDD[0].value,
                            SelectedVersionsName: SelectedVerName
                        });
                        $(`#${SDIConstants.SDILoader}`).addClass('hide');
                    }
                }
            }
        }
    }
    BindBuildVersions = () => {
        return this.state.VersionsDD.map((value, index) => {
            let classname = "sdi-release-nav nav-link";
            if (index == this.state.SelectedVersionsInd) {
                classname = "sdi-release-nav nav-link active";
            }
            let actid = "v-pills-home-tab" + index;
            return (<a className={classname} id={actid} data-toggle="pill" onClick={(e) => this.SelectVersionChange(e, value.value)} href="#v-pills-home" role="tab" aria-controls="v-pills-home" aria-selected="true">{value.label}</a>)
        });
    }
    BindVersionDD = () => {
        return this.state.VersionsDD.map((value, index) => {
            return (<option value={value.value}>{value.label}</option>)
        });
    }
    BindBuildTasks = () => {
        return this.state.VersionTaskArray.map((value, index) => {
            return (<li>{value.TASK_TITLE}</li>)
        });
    }
    BackNavigation = (e) => {
        
        e.preventDefault();
        let pagePath = CookieService.getLocalStorageValues("Session_PageName")
        let searchKey = CookieService.getLocalStorageValues("searchKey");
        if (pagePath.includes("searchresults")) {
            let searchkeyvalue = searchKey.replace(/&/g, "%26") //WW-875_PC_01
            searchkeyvalue = searchkeyvalue.replace(/#/g, "%23")
            this.props.history.push({

                pathname: `\searchresults`,
                search: `?key=${searchkeyvalue}&Make=&Model=&AssetId=&`,
                state: { ImageSearch: false, ImageFiles: "", image: "" }
            });
        }
        else if (pagePath.includes("itemdetailnew")) {
            let mfgPartNo = CookieService.getLocalStorageValues("ItemDetMfgPartNo");
            let mfgMfgName = CookieService.getLocalStorageValues("ItemDetMfgPartName");
            let vendorId = CookieService.getLocalStorageValues("ItemDetVendId");
            let Wo = localStorage.getItem("WONum") != null ? JSON.parse(localStorage.getItem("WONum")) : "";
            let SelectedValue = CookieService.getLocalStorageValues("ItemDetItemdata");
            let locAlternateParts = CookieService.getLocalStorageValues("ItemDetAltData");
            this.props.history.push({
                pathname: `\itemdetailnew`,
                search: `?ItemId=${mfgPartNo}&ManufacturePartNumber=${mfgPartNo}&ManufactureName=${mfgMfgName}&SupplierID=${vendorId}&QTY=`,
                state: { WO: Wo, ItemData: SelectedValue, Suggesstions: false, AlternateParts: locAlternateParts }
            });
        }
        else {
            this.props.history.push({
                pathname: pagePath,
            });
        }

    }
    PrevNextClick = (e, type) => {
        e.preventDefault();
        let SelectedVerInd;
        let Prev = "-";
        let Next = "-";
        let buildDate = "";
        let date;
        let month;
        let year;
        let FullDate;
        let currVersion = this.state.SelectedVersionsNo;
        let curVerInd = this.state.VersionsDD.findIndex((x) => x.value == currVersion);
        if (type == "Prev") {
            SelectedVerInd = curVerInd + 1;
        }
        else {
            SelectedVerInd = curVerInd - 1;
        }
        if (SelectedVerInd == 0) {
            Prev = this.state.VersionsDD[SelectedVerInd + 1].label;
            Next = "-";
        }
        else if (SelectedVerInd == (this.state.VersionsDD.length - 1)) {
            Prev = "-";
            Next = this.state.VersionsDD[SelectedVerInd - 1].label
        }
        else {
            Prev = this.state.VersionsDD[SelectedVerInd + 1].label;
            Next = this.state.VersionsDD[SelectedVerInd - 1].label;
        }
        let TasksArray = this.state.historyArray.filter((x) => x.VERSION_NO == this.state.VersionsDD[SelectedVerInd].value);
        TasksArray = TasksArray.sort((a, b) => a.TASK_NO - b.TASK_NO);
        let SelectedVerName = this.state.VersionsDD[SelectedVerInd].label;
        let SelectedVerNo = this.state.VersionsDD[SelectedVerInd].value;
        buildDate = TasksArray[0].ADD_DTTM;
        FullDate = new Date(buildDate);
        year = FullDate.getFullYear();
        month = FullDate.toLocaleString("default", { month: "long" });
        date = FullDate.getDate()
        buildDate = month + " " + date + ", " + year;
        this.setState({
            VersionTaskArray: TasksArray, PrevNav: Prev, NextNav: Next, SelectedVersionsInd: SelectedVerInd, SelectedVersionsDate: buildDate, SelectedVersionsNo: this.state.VersionsDD[SelectedVerInd].value,
            SelectedVersionsName: SelectedVerName, Versionchange: SelectedVerNo
        });
    }
    SelectVersionChange = (event, version) => {
        
        if (version == undefined) {
            version = event.target.value;
        }
        let TasksArray = this.state.historyArray.filter((x) => x.VERSION_NO == version);
        TasksArray = TasksArray.sort((a, b) => a.TASK_NO - b.TASK_NO);
        let Prev = "-";
        let Next = "-";
        let SelectedVerInd = this.state.VersionsDD.findIndex((x) => x.value == version);
        if (SelectedVerInd == 0) {
            Prev = this.state.VersionsDD[SelectedVerInd + 1].label;
            Next = "-";
        }
        else if (SelectedVerInd == (this.state.VersionsDD.length - 1)) {
            Prev = "-";
            Next = this.state.VersionsDD[SelectedVerInd - 1].label;
        }
        else {
            Prev = this.state.VersionsDD[SelectedVerInd + 1].label;
            Next = this.state.VersionsDD[SelectedVerInd - 1].label;
        }
        let buildDate = TasksArray[0].ADD_DTTM;
        let date;
        let month;
        let year;
        let FullDate = new Date(buildDate);
        year = FullDate.getFullYear();
        month = FullDate.toLocaleString("default", { month: "long" });
        date = FullDate.getDate()
        buildDate = month + " " + date + ", " + year;
        let SelectedVerName = this.state.VersionsDD[SelectedVerInd].label;
        this.setState({
            VersionTaskArray: TasksArray, PrevNav: Prev, NextNav: Next, SelectedVersionsInd: SelectedVerInd, SelectedVersionsDate: buildDate, SelectedVersionsNo: version,
            SelectedVersionsName: SelectedVerName, Versionchange: event.target.value
        });
    }

    render() {
        var height = $(window).height() - (62 + 210);
        $(".sdi-overflow").attr('style', `height:${height}px !important`);
        let appClassName = "container-fluid content-section content-margin";
        let appClassName1 = "container-fluid content-section";
        if (isFromLink) {
            appClassName = "container-fluid";
            appClassName1 = "container-fluid releasenotestop";
        }
        return (
            <div className={appClassName1}>
                <div className={appClassName}>
                    <div className="row">
                        {/* Back Arrow with release notes label - Desktop */}

                        <div className="col-md-12 d-lg-none mb-1">
                            <label className="sdi-release-label mb-4"><span>{isFromLink == false ? <a ><img src="images/release-back-arrow.svg" alt="back-icon" className="sdi-back-icon mr-2" /></a> : null}</span>Release Notes <span><img src="images/release-launch.svg" alt="launch-icon" className="sdi-launch-icon ml-1" /></span></label>
                        </div>
                        {/* Left Nav - Desktop */}
                        <div className="col-md-2 sdi-release-nav sdi-overflow border-right d-none d-lg-block">
                            <label className="sdi-release-label mb-4"> {isFromLink == false ? <span style={{ cursor: "Pointer" }}> <img src="images/release-back-arrow.svg" onClick={e => this.BackNavigation(e)} alt="back-icon" className="sdi-back-icon mr-2" /> </span> : null} Release Notes <span><img src="images/release-launch.svg" alt="launch-icon" className="sdi-launch-icon ml-1" /></span></label>
                            <div className="nav flex-column nav-pills" id="v-pills-tab" role="tablist" aria-orientation="vertical">
                                {this.state.VersionsDD.length > 0 ? this.BindBuildVersions() : null}
                            </div>
                        </div>
                        <div className="col-12 d-lg-none mb-3"  >

                            <select class="sdi-category-dropdown form-control" name="Versionchange" value={this.state.Versionchange} onChange={(e) => this.SelectVersionChange(e)}>
                                {this.state.VersionsDD.length > 0 ? this.BindVersionDD() : null}
                            </select>
                        </div>
                        {/* Right side Content - Desktop */}
                        <div className="col-md-12 col-lg-10 pr-4">
                            <div className="tab-content" id="v-pills-tabContent">
                                <div className="tab-pane fade active show" id="v-pills-home" role="tabpanel" aria-labelledby="v-pills-home-tab">
                                    <h1 className="sdi-release-font-bold mb-3">{this.state.SelectedVersionsName}</h1>
                                    <label className="sdi-version-label border-bottom "><span><img src="images/calendar.svg" alt="calendar-icon" className="sdi-calendar-img mr-1" /></span>{`Updated on ${this.state.SelectedVersionsDate}`}</label>
                                    <h2 className="sdi-new-release">Check out What’s new in ZEUS!</h2>
                                    <ul className="sdi-release-notes-gap mt-4">
                                        {this.state.VersionTaskArray.length > 0 ? this.BindBuildTasks() : null}
                                    </ul>
                                </div>
                                <div className="tab-pane fade" id="v-pills-profile" role="tabpanel" aria-labelledby="v-pills-profile-tab">...</div>
                                <div className="tab-pane fade" id="v-pills-messages" role="tabpanel" aria-labelledby="v-pills-messages-tab">...</div>
                                <div className="tab-pane fade" id="v-pills-settings" role="tabpanel" aria-labelledby="v-pills-settings-tab">...</div>
                            </div>
                            <div className="d-flex justify-content-between mt-5 pt-4 border-top">
                                <div className="float-left">
                                    {this.state.PrevNav != "-" ? <>
                                        <a href="#" className="sdi-page-nav" onClick={(e) => this.PrevNextClick(e, "Prev")}>Previous</a>
                                        <p className="mt-2 sdi-font-bold">{this.state.PrevNav}</p></> : null}
                                </div>
                                <div className="float-right">{this.state.NextNav != "-" ? <>
                                    <a href="#" className="sdi-page-nav" onClick={(e) => this.PrevNextClick(e, "Next")}>Next</a>
                                    <p className="mt-2 sdi-font-bold">{this.state.NextNav}</p></> : null}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
export default withTranslation()(BuildHistoryComponent);